import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import moment from "moment"

import GuestLayout from "../components/GuestLayout"

import * as cartSlice from "../store/cart"
import * as productApis from "../utilities/apis/product"
import { url } from "../utilities/enumerations/constants"

const Product = () => {
  const dispatch = useDispatch()
  const cartState = useSelector((state) => state.cart)
  const { token } = useSelector((state) => state.user)
  const { slug } = useParams()
  const [product, setProduct] = useState(null)

  const handleCart = async () => {
    dispatch(cartSlice.addToCart(product))
  }

  const handleDecrement = async () => {
    dispatch(cartSlice.handleDecrement(product.slug))
  }

  const handleIncrement = async () => {
    if (cartState.productsById[product.slug] >= 10) return alert('For more than 10 quantity please contact our support on whatsapp')
    dispatch(cartSlice.handleIncrement(product.slug))
  }

  const getProduct = async () => {
    try {
      const response = await productApis.getHomeProduct(slug)
      if (!response.status) throw new Error(response.message)

      setProduct(response.product)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (slug) getProduct()
  }, [slug])

  if (!product) return

  let src = "/upload-white.png"
  if (product.thumbnail) src = product.thumbnail
  // if (product.thumbnail_url) src = product.thumbnail_url.replace("public", url)

  return (
    <GuestLayout
      header={true}
      footer={true}
    >
      <div className="container py-4">
        <div className="row gy-3 gy-md-0 mb-4">
          <div className="col-md-4">
            {product.video_url && <iframe src={product.video_url} className="thumbnail rounded"></iframe>}
            {!product.video_url && <img src={src} alt={product.title} className="thumbnail rounded" />}
          </div>
          <div className="col-md-8">
            <div className="d-flex flex-column gap-4">
              <h1 className="fw-bold m-0">{product.title}</h1>

              <div>
                <p className="text-muted fw-bold m-0">Description</p>
                <p className="m-0">{product.description}</p>
              </div>

              <div className="d-flex gap-3 align-items-center">
                <p className="fs-3 bg-theme-light px-2 rounded text-theme fw-bold">Rs. {product.price.toFixed(2)}</p>
              </div>

              {
                !cartState.productsById[product.slug]
                  ? <button className="btn btn-lg btn-theme w-25" onClick={handleCart}>Add to Cart</button>
                  : <div className="d-flex gap-3 justify-content-between align-items-center w-25">
                    <button type="button" className="btn btn-lg btn-light-theme flex-grow-1" onClick={handleDecrement}><i className="bi bi-dash-lg"></i></button>
                    <p className="flex-grow-1 fs-5 text-muted text-center fw-bold m-0">{cartState.productsById[product.slug]}</p>
                    <button type="button" className="btn btn-lg btn-light-theme flex-grow-1" onClick={handleIncrement}><i className="bi bi-plus-lg"></i></button>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
    </GuestLayout>
  )
}

export default Product
